import { useEffect, useState, startTransition } from 'react';
import { Fade, Slide } from 'react-awesome-reveal';

function useHydrated() {
    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        startTransition(() => setHydrated(true));
    }, []);

    return hydrated;
}

export function HydrationSafeFade({ children, ...props }) {
    const hydrated = useHydrated();

    if (!hydrated) return <>{children}</>;
    return <Fade {...props}>{children}</Fade>;
}

export function HydrationSafeSlide({ children, ...props }) {
    const hydrated = useHydrated();

    if (!hydrated) return <>{children}</>;
    return <Slide {...props}>{children}</Slide>;
}
